<div
	class="shift-holder"
		 *ngIf="_shift !== undefined"
		 (click)="editShift(_shift)"
		 [class.warning]="
				_shift.user.id === 1 ||
        _availabilities.length !== 0 ||
        (!(user$ | async)?.isAdmin() && _shift.public_shift_stock_id && (user$ | async).id === _shift.user.id)
      "
		 [class.all-good]="_shift.approved"
		 [class.has-top-icon]="_shift.approved || _shift.has_punch_start"
		 [class.has-bottom-icon]="_availabilities.length !== 0 || _shift.punch_not_approved_reasons.length !== 0"
		 [class.sick]="!_shift.approved && _shift.sick_message_id"
		 [class.available]="_shift.user.id === 1"
>
	<div class="group" *ngIf="viewType === VIEW_TYPES.PERSON_VIEW || !fromSchedule"
			 [class.userDeleted]="_shift.group.deleted_at">{{_shift.group.group_name}}</div>
	<div class="group" *ngIf="viewType === VIEW_TYPES.GROUP_VIEW && fromSchedule"
			 [class.userDeleted]="_shift.user.deleted_at || _shift.user.deactivated_at">{{_shift.user.getFullName()}}</div>
	<div class="times">{{_shift.start.localDate.format('LT')}} - {{_shift.end.localDate.format('LT')}}</div>
	<div
		*ngIf="_shift.amount_of_bids_on_shift > 0"
		class="icon all-good bids-on-shift"
		matTooltipClass="text-align-left"
		matTooltip="{{ 'SCHEDULE.SHIFT_HAS_BIDS' | translate }} ({{_shift.amount_of_bids_on_shift}})"
	>
		<qo-icon [icon]="EQORebrandIcon.arrow_down_dark" [color]="EQORebrandColor.WHITE" [size]="'tn'"></qo-icon>
	</div>
	<div
		*ngIf="_shift.bid_on_shift"
		matTooltipClass="text-align-left"
		matTooltip="{{ 'SCHEDULE.YOU_HAVE_BID_ON_THE_SHIFT' | translate }}" class="icon all-good bids-on-shift"
	>
		<qo-icon [icon]="EQORebrandIcon.arrow_down_dark" [color]="EQORebrandColor.WHITE" [size]="'tn'"></qo-icon>
	</div>
	<div
		*ngIf="_shift.approved"
		class="icon approved-icon"
		matTooltip="{{ 'SCHEDULE.SHIFT_IS_APPROVED' | translate }}"
	>
		<qo-icon [icon]="EQORebrandIcon.salary_dark" [color]="EQORebrandColor.SHIFT_APPROVAL" [size]="'tn'"></qo-icon>
	</div>
	<div
		*ngIf="!_shift.approved && _shift.has_punch_end"
		class="icon punched-out-icon"
		matTooltip="{{ 'SCHEDULE.SHIFT_HAS_PUNCH_IN_AND_OUT' | translate }}"
	>
		<qo-icon [icon]="EQORebrandIcon.timer_dark" [size]="'tn'"></qo-icon>
	</div>
	<div class="icon punched-in-icon" matTooltip="{{ 'SCHEDULE.SHIFT_HAS_PUNCH_IN' | translate }}"
			 *ngIf="!_shift.approved && _shift.has_punch_start && !_shift.has_punch_end">
		<qo-icon [icon]="EQORebrandIcon.close_dark_filled" [color]="EQORebrandColor.WHITE" [size]="'tn'"></qo-icon>
	</div>
	<div
		*ngIf="!_shift.approved && _shift.sick_message_id"
		class="icon sick-icon"
		matTooltip="{{ 'SCHEDULE.SICK_DAY_ON_SHIFT' | translate }}"
	>
		<qo-icon [icon]="EQORebrandIcon.sick_dark" [color]="EQORebrandColor.SHIFT_OUT_SICK" [size]="'tn'"></qo-icon>
	</div>
	<div
		*ngIf="_availabilities.length !== 0 && _shift.punch_not_approved_reasons.length === 0"
		class="icon availability-icon"
		matTooltipClass="text-align-left"
		[matTooltip]="availabilitiesTooltip"
	>
		<qo-icon [icon]="EQORebrandIcon.vacation_airplane_dark" [color]="EQORebrandColor.WARNING" [size]="'tn'"></qo-icon>
	</div>
	<div
		*ngIf="_shift.punch_not_approved_reasons.length !== 0"
		class="icon problems-icon"
		matTooltipClass="text-align-left"
		[matTooltip]="problemsTooltip + '\n' + availabilitiesTooltip"
		[ngClass]="_shift.approved ? 'all-good': 'warning'"

	>
		<qo-icon [icon]="EQORebrandIcon.info_dark" [color]="EQORebrandColor.WARNING" [size]="'tn'"></qo-icon>
	</div>

</div>
<div
	class="new-shift-holder"
	*ngIf="(user$ | async)?.isAdmin() && _shift === undefined && fromSchedule"
	(click)="editShift(null)"
>
	<qo-icon [icon]="EQORebrandIcon.plus_dark" [color]="EQORebrandColor.SECONDARY" [size]="'sm'"></qo-icon>
</div>

